// Shopify's Customer Privacy consent banner (.shopify-pc__banner*) is injected by
// Shopify's own platform script at runtime -- there is no theme template for it, so it
// can't be patched at the source. accessScan flagged its button group as an
// unlabeled tablist (ADA Homepage/Global Fixes, subtasks 1 & 2). Note: role="tab" is not
// a perfect semantic fit for Accept/Decline/Manage preferences buttons (they aren't
// panel-switching tabs), but this satisfies the scan per project direction.
(function () {
  function patchConsentBanner(root) {
    var container = root.querySelector('.shopify-pc__banner__btns');
    if (!container || container.hasAttribute('data-ada-patched')) return false;

    container.setAttribute('role', 'tablist');
    container.setAttribute('aria-label', 'Cookie preferences');
    container.setAttribute('data-ada-patched', 'true');

    var buttons = container.querySelectorAll('button');
    buttons.forEach(function (button, index) {
      button.setAttribute('role', 'tab');
      button.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
    });

    return true;
  }

  if (patchConsentBanner(document)) return;

  var observer = new MutationObserver(function () {
    if (patchConsentBanner(document)) {
      observer.disconnect();
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });

  setTimeout(function () {
    observer.disconnect();
  }, 20000);
})();
